import {Component} from '@angular/core';
import {
  CompanySimpleDto,
  DictionaryBaseDto,
  PolicyContractPrimeDebtorCompanyDto,
} from '../../../../../bonding_shared/model';
import {Section} from '../section';
import {AppConfigService, RouterService} from '../../../../../bonding_shared/services';
import {PolicyContractCompanyRole} from '../../../../../bonding_shared/model/dictionary-ids';
import {PolicyContractViewService} from '../../../services/policy-contract-view.service';

@Component({
  selector: 'policy-prime-debtors-section',
  templateUrl: './policy-prime-debtors-section.component.pug',
})
export class PolicyPrimeDebtorsSectionComponent extends Section {
  constructor(
    protected policyContractViewService: PolicyContractViewService,
    protected appService: AppConfigService,
    public router: RouterService
  ) {
    super(policyContractViewService, appService);
  }

  addPrimeDebtors(company: CompanySimpleDto) {
    this.policy.primeDebtors.push(<PolicyContractPrimeDebtorCompanyDto>{
      role: <DictionaryBaseDto>{id: PolicyContractCompanyRole.PRIME_DEBTORS},
      company: company,
      multiplierValue: 1,
    });
  }
}
